<template lang="html">
  <div class="query-section" id="to-here">
    <span class="main-title" :class="{ 'blur' : $root.blur }">
      INNOVA EN SUS SERVICIOS!
    </span>
    <span class="label welcome" :class="{ 'blur' : $root.blur }">{{ !mode ? 'Obtenga su credencial de Registro Mercantil' : 'Valide su credencial de Registro Mercantil' }}</span>
    <div class="btn-change-mode" @click="changeMode" :class="{ 'blur' : $root.blur }">
      <div class="help-btn">
        <svg class="move-touch" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 469.333 469.333" style="enable-background:new 0 0 469.333 469.333;" xml:space="preserve" width="512px" height="512px">
          <g>
          	<g>
          		<path ref="hand" class="hand" d="M438.827,186.347l-80.213-88.149c-15.872-15.872-41.728-15.893-57.749,0.128c-5.077,5.077-8.533,11.157-10.325,17.643    c-15.957-12.224-38.976-11.008-53.675,3.691c-5.056,5.077-8.512,11.157-10.347,17.621c-15.957-12.181-38.976-10.987-53.653,3.712    c-4.971,4.971-8.384,10.901-10.24,17.216l-37.803-37.803c-15.872-15.872-41.728-15.893-57.749,0.128    c-15.893,15.872-15.893,41.728,0,57.621l145.237,145.237l-86.144,13.525c-23.275,3.328-40.832,23.552-40.832,47.083    c0,17.643,14.357,32,32,32h201.152c31.339,0,60.8-12.203,82.965-34.368l33.557-33.557c22.144-22.123,34.325-51.563,34.325-82.859    C469.333,235.989,458.496,207.979,438.827,186.347z M419.925,332.992l-33.557,33.557c-18.133,18.133-42.24,28.117-67.883,28.117    H117.333c-5.888,0-10.667-4.779-10.667-10.667c0-12.971,9.685-24.128,22.677-25.984l106.987-16.811    c3.968-0.619,7.232-3.413,8.491-7.232c1.237-3.797,0.235-8-2.603-10.837L82.155,163.072c-7.573-7.573-7.573-19.904,0.107-27.605    c3.797-3.776,8.768-5.675,13.739-5.675c4.971,0,9.941,1.899,13.739,5.696l106.731,106.731c4.16,4.16,10.923,4.16,15.083,0    c2.069-2.091,3.115-4.821,3.115-7.552s-1.045-5.461-3.136-7.552l-43.584-43.584c-7.573-7.573-7.573-19.883,0.128-27.584    c7.552-7.552,19.904-7.552,27.456,0l43.605,43.605c4.16,4.16,10.923,4.16,15.083,0c2.069-2.091,3.115-4.821,3.115-7.552    c0-2.731-1.045-5.461-3.136-7.552l-22.251-22.251c-7.573-7.573-7.573-19.883,0.128-27.584c7.552-7.552,19.904-7.552,27.456,0    l22.357,22.357c0.043,0.021,0.021,0.021,0.021,0.021l0.021,0.021c0.021,0.021,0.021,0.021,0.021,0.021    c0.021,0.021,0.021,0.021,0.021,0.021h0.021c0.021,0,0.021,0.021,0.021,0.021c4.181,3.968,10.795,3.883,14.869-0.213    c4.16-4.16,4.16-10.923,0-15.083l-0.917-0.917c-3.669-3.669-5.696-8.555-5.696-13.739s2.005-10.048,5.803-13.845    c7.595-7.552,19.883-7.531,27.115-0.363l79.872,87.787C439.125,218.389,448,241.301,448,265.216    C448,290.816,438.037,314.88,419.925,332.992z" />
          	</g>
          </g>
          <g>
          	<g>
          		<path class="ja" ref="ja" d="M183.381,109.931C167.851,75.563,133.547,53.333,96,53.333c-52.928,0-96,43.072-96,96    c0,37.547,22.229,71.851,56.597,87.403c1.429,0.64,2.923,0.939,4.395,0.939c4.053,0,7.936-2.347,9.728-6.272    c2.411-5.376,0.021-11.691-5.333-14.123c-26.752-12.096-44.053-38.763-44.053-67.947c0-41.173,33.493-74.667,74.667-74.667    c29.184,0,55.851,17.301,67.947,44.053c2.411,5.376,8.747,7.787,14.101,5.333C183.424,121.621,185.813,115.307,183.381,109.931z" fill="transparent"/>
          	</g>
          </g>
        </svg>
      </div>
      <div class="arrow">
        <svg class="move-touch" xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="0 -33 474 474" width="512px">
          <path d="m305.820312 314.449219c-2.785156-2.683594-7.21875-2.601563-9.902343.183593l-39.289063 40.765626c-2.625 2.722656-2.613281 7.03125.019532 9.738281l39.292968 40.429687c2.691406 2.769532 7.125 2.832032 9.898438.140625 2.769531-2.695312 2.832031-7.128906.140625-9.898437l-28.488281-29.308594h59.914062c43.324219-.03125 78.417969-35.179688 78.386719-78.5v-.109375c0-3.867187-3.132813-7-7-7-3.863281 0-7 3.132813-7 7v.113281c.03125 35.59375-28.796875 64.472656-64.390625 64.5h-58.535156l27.132812-28.15625c2.683594-2.785156 2.605469-7.214844-.179688-9.898437zm0 0" fill="#2295f1"/>
          <path d="m170.769531 93.238281c2.78125 2.6875 7.214844 2.605469 9.898438-.179687l39.292969-40.773438c2.621093-2.71875 2.613281-7.027344-.019532-9.734375l-39.296875-40.429687c-2.695312-2.773438-7.125-2.835938-9.898437-.140625-2.773438 2.695312-2.835938 7.125-.140625 9.898437l28.039062 28.847656h-59.46875c-43.277343.082032-78.335937 35.164063-78.386719 78.445313v.355469c.105469 3.789062 3.203126 6.808594 6.996094 6.8125h.191406c3.8125-.105469 6.839844-3.242188 6.8125-7.054688v-.058594c.007813-35.574218 28.8125-64.429687 64.390626-64.5h58.980468l-27.574218 28.621094c-2.679688 2.785156-2.597657 7.210938.183593 9.890625zm0 0" fill="#2295f1"/>
        </svg>
      </div>
      <div class="cert" :class="{ 'active' : !mode }">
        <svg class="move-touch" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="512px" height="512px">
          <g>
          	<g>
          		<path d="M401.777,137.141H110.223c-4.146,0-7.506,3.36-7.506,7.506s3.36,7.506,7.506,7.506h291.554    c4.146,0,7.506-3.36,7.506-7.506S405.923,137.141,401.777,137.141z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M401.777,218.869H110.223c-4.146,0-7.506,3.36-7.506,7.506c0,4.145,3.36,7.506,7.506,7.506h291.554    c4.146,0,7.506-3.36,7.506-7.506S405.923,218.869,401.777,218.869z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M306.193,271.909H205.807c-4.146,0-7.506,3.36-7.506,7.506c0,4.145,3.36,7.506,7.506,7.506h100.386    c4.146,0,7.506-3.36,7.506-7.506C313.699,275.269,310.339,271.909,306.193,271.909z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M401.777,177.838H184.303c-4.146,0-7.506,3.36-7.506,7.506c0,4.145,3.36,7.506,7.506,7.506h217.474    c4.146,0,7.506-3.36,7.506-7.506S405.923,177.838,401.777,177.838z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M149.381,177.837h-39.158c-4.146,0-7.506,3.36-7.506,7.506s3.36,7.506,7.506,7.506h39.158c4.146,0,7.506-3.36,7.506-7.506    C156.887,181.198,153.527,177.837,149.381,177.837z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M473.251,124.455c-1.746-1.715-4.057-2.659-6.522-2.659c-0.002,0-0.003,0-0.005,0c-15.213,0-27.664-11.892-28.349-27.078    c-0.225-4.938-4.283-8.805-9.238-8.805H81.077c-4.956,0-9.015,3.868-9.239,8.81c-0.653,14.511-12.532,26.391-27.044,27.044    c-4.94,0.222-8.809,4.281-8.809,9.239v194.021c0,4.958,3.869,9.016,8.809,9.238c14.512,0.654,26.391,12.533,27.044,27.049    c0.225,4.938,4.284,8.805,9.239,8.805h221.577c4.146,0,7.506-3.36,7.506-7.506c0-4.145-3.36-7.506-7.506-7.506H86.239    c-3.103-18.079-17.164-32.14-35.243-35.244V136.167c18.079-3.103,32.14-17.167,35.243-35.243h337.739    c3.23,18.65,18.245,33.046,37.026,35.51v127.469c0,4.145,3.36,7.506,7.506,7.506c4.146,0,7.506-3.36,7.506-7.506V131.048    C476.016,128.549,475.034,126.207,473.251,124.455z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M491.165,48.445H20.835C9.347,48.445,0,57.792,0,69.28v317.47c0,11.489,9.347,20.835,20.835,20.835h315.048    l-11.154,23.373c-1.433,3.001-1.084,6.52,0.908,9.182c1.993,2.663,5.272,3.986,8.553,3.461l20.766-3.338l11.583,19.013    c1.624,2.668,4.51,4.278,7.611,4.278c0.151,0,0.303-0.004,0.455-0.012c3.272-0.166,6.181-2.106,7.594-5.064l20.126-42.173    l20.124,42.17c1.41,2.958,4.319,4.9,7.592,5.068c0.153,0.008,0.307,0.012,0.459,0.012c3.101,0,5.987-1.61,7.611-4.277    l11.583-19.013l20.766,3.339c3.291,0.526,6.564-0.801,8.555-3.465c1.992-2.664,2.338-6.182,0.905-9.178l-11.154-23.373h22.399    c11.488,0,20.835-9.346,20.835-20.835V69.28C512,57.792,502.653,48.445,491.165,48.445z M373.501,441.85l-7.857-12.895    c-1.892-3.106-5.434-4.74-9.028-4.163l-13.334,2.144l14.046-29.432c5.536,5.649,13.423,8.701,21.61,7.93    c2.799-0.268,5.605,0.486,7.898,2.115c0.756,0.538,1.541,1.015,2.336,1.465L373.501,441.85z M404.115,397.342    c-0.023,0.003-0.046,0.005-0.07,0.009c-1.138,0.168-2.295,0.168-3.433,0.001c-0.029-0.004-0.058-0.007-0.086-0.011    c-1.763-0.273-3.477-0.948-4.995-2.027c-4.54-3.228-9.961-4.944-15.491-4.944c-0.838,0-1.678,0.04-2.518,0.119    c-4.969,0.469-9.69-2.26-11.764-6.792c-0.921-2.012-2.096-3.874-3.46-5.577c-0.06-0.085-0.126-0.165-0.189-0.247    c-0.076-0.092-0.147-0.187-0.223-0.278c-0.087-0.102-0.178-0.199-0.271-0.296c-2.482-2.856-5.549-5.188-9.042-6.786    c-4.533-2.074-7.262-6.802-6.792-11.765c0.604-6.386-1.109-12.782-4.825-18.009c-2.889-4.063-2.889-9.522-0.001-13.585    c3.717-5.227,5.43-11.623,4.826-18.009c-0.47-4.963,2.26-9.691,6.792-11.765c5.833-2.669,10.515-7.351,13.184-13.184    c2.075-4.533,6.813-7.263,11.765-6.792c6.393,0.603,12.783-1.11,18.01-4.826c4.064-2.888,9.523-2.888,13.585,0    c5.228,3.716,11.619,5.425,18.01,4.826c4.967-0.472,9.692,2.26,11.766,6.792c2.669,5.833,7.351,10.515,13.183,13.183    c4.533,2.075,7.263,6.803,6.793,11.765c-0.604,6.387,1.109,12.783,4.825,18.009c2.889,4.063,2.889,9.522,0,13.585    c-3.716,5.228-5.429,11.624-4.825,18.009c0.47,4.963-2.26,9.691-6.794,11.766c-3.485,1.595-6.545,3.921-9.024,6.768    c-0.102,0.106-0.202,0.213-0.296,0.324c-0.065,0.078-0.126,0.159-0.191,0.238c-0.075,0.096-0.151,0.19-0.221,0.289    c-1.36,1.7-2.532,3.558-3.45,5.565c-2.075,4.532-6.803,7.263-11.766,6.792c-6.38-0.601-12.78,1.109-18.01,4.825    C407.597,396.394,405.881,397.07,404.115,397.342z M448.033,424.791c-3.595-0.575-7.135,1.058-9.028,4.165l-7.856,12.895    l-15.671-32.837c0.795-0.45,1.579-0.927,2.336-1.465c2.294-1.63,5.102-2.386,7.898-2.116c8.19,0.772,16.075-2.28,21.611-7.929    l14.045,29.431L448.033,424.791z M496.989,386.751c0,3.211-2.612,5.824-5.824,5.824h-29.563l-3.87-8.11    c0.195-0.103,0.389-0.211,0.591-0.303c10.336-4.731,16.561-15.513,15.49-26.829c-0.265-2.8,0.486-5.605,2.116-7.898    c6.586-9.265,6.586-21.715-0.001-30.98c-1.629-2.292-2.38-5.096-2.115-7.897c1.071-11.316-5.154-22.098-15.491-26.829    c-2.557-1.171-4.61-3.224-5.781-5.781c-4.73-10.337-15.517-16.56-26.83-15.49c-2.802,0.267-5.605-0.486-7.897-2.116    c-9.265-6.586-21.716-6.587-30.98,0c-2.293,1.63-5.104,2.383-7.897,2.115c-11.33-1.066-22.1,5.154-26.829,15.49    c-1.171,2.558-3.224,4.61-5.782,5.781c-10.336,4.731-16.561,15.512-15.49,26.829c0.265,2.801-0.486,5.605-2.116,7.898    c-6.586,9.265-6.586,21.715,0,30.979c1.63,2.292,2.381,5.097,2.116,7.898c-1.071,11.317,5.154,22.099,15.49,26.829    c0.202,0.092,0.395,0.2,0.59,0.303l-3.87,8.111H20.835c-3.211,0-5.824-2.612-5.824-5.824V69.28c0-3.211,2.612-5.824,5.824-5.824    h470.33c3.211,0,5.824,2.613,5.824,5.824V386.751z" fill="#2295f1"/>
          	</g>
          </g>
          <g>
          	<g>
          		<path d="M401.777,287.312c-25.714,0-46.634,20.92-46.634,46.633c0,25.714,20.92,46.634,46.634,46.634s46.633-20.921,46.633-46.634    C448.41,308.231,427.491,287.312,401.777,287.312z M401.777,365.567c-17.437,0-31.623-14.186-31.623-31.623    c0-17.436,14.186-31.622,31.623-31.622c17.436,0,31.622,14.186,31.622,31.622C433.399,351.381,419.213,365.567,401.777,365.567z" fill="#2295f1"/>
          	</g>
          </g>
        </svg>
      </div>
      <div class="qr-btn" :class="{ 'active' : mode }">
        <svg class="move-touch" xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="-21 -21 682.66669 682" width="512px"><path d="m77.289062 88.605469v173.5625c0 6.933593 5.621094 12.550781 12.550782 12.550781h173.566406c6.929688 0 12.550781-5.617188 12.550781-12.550781v-32.910157c0-6.933593-5.621093-12.550781-12.550781-12.550781s-12.546875 5.617188-12.546875 12.550781v20.363282h-148.46875v-148.46875h148.46875v30.214844c0 6.933593 5.617187 12.554687 12.546875 12.554687s12.550781-5.621094 12.550781-12.554687v-42.761719c0-6.933594-5.621093-12.550781-12.550781-12.550781h-173.566406c-6.929688 0-12.550782 5.617187-12.550782 12.550781zm0 0" fill="#2295f1"/><path d="m150.589844 136.804688c-6.933594 0-12.546875 5.617187-12.546875 12.546874v52.070313c0 6.929687 5.613281 12.550781 12.546875 12.550781h52.070312c6.929688 0 12.550782-5.621094 12.550782-12.550781v-52.070313c0-6.929687-5.621094-12.546874-12.550782-12.546874zm39.523437 52.070312h-26.972656v-26.972656h26.972656zm0 0" fill="#2295f1"/><path d="m263.40625 364.34375h-173.566406c-6.929688 0-12.550782 5.617188-12.550782 12.546875v173.570313c0 6.929687 5.621094 12.546874 12.550782 12.546874h173.566406c6.929688 0 12.550781-5.617187 12.550781-12.546874v-173.570313c0-6.929687-5.621093-12.546875-12.550781-12.546875zm-12.546875 173.566406h-148.46875v-148.46875h148.46875zm0 0" fill="#2295f1"/><path d="m379 274.71875h173.570312c6.925782 0 12.546876-5.617188 12.546876-12.550781v-173.5625c0-6.933594-5.621094-12.550781-12.546876-12.550781h-173.570312c-6.929688 0-12.550781 5.617187-12.550781 12.550781v173.5625c0 6.933593 5.621093 12.550781 12.550781 12.550781zm12.546875-173.566406h148.46875v148.46875h-148.46875zm0 0" fill="#2295f1"/><path d="m565.117188 550.460938v-173.570313c0-6.929687-5.621094-12.546875-12.546876-12.546875h-173.570312c-6.929688 0-12.550781 5.617188-12.550781 12.546875v173.570313c0 6.929687 5.621093 12.546874 12.550781 12.546874h173.570312c6.925782 0 12.546876-5.617187 12.546876-12.546874zm-25.101563-12.550782h-148.46875v-148.46875h148.46875zm0 0" fill="#2295f1"/><path d="m552.570312 332.839844c6.925782 0 12.546876-5.621094 12.546876-12.550782 0-6.933593-5.621094-12.546874-12.546876-12.546874h-220.03125v-220.527344c0-6.929688-5.621093-12.550782-12.546874-12.550782-6.9375 0-12.554688 5.621094-12.554688 12.550782v220.527344h-166.570312c-6.925782 0-12.546876 5.617187-12.546876 12.546874 0 6.933594 5.621094 12.550782 12.546876 12.550782h166.570312v217.621094c0 6.929687 5.617188 12.546874 12.554688 12.546874 6.925781 0 12.546874-5.617187 12.546874-12.546874v-217.621094zm0 0" fill="#2295f1"/><path d="m150.589844 503.195312h52.070312c6.929688 0 12.550782-5.621093 12.550782-12.550781v-52.070312c0-6.933594-5.621094-12.546875-12.550782-12.546875h-52.070312c-6.933594 0-12.546875 5.613281-12.546875 12.546875v52.070312c0 6.929688 5.613281 12.550781 12.546875 12.550781zm12.550781-52.070312h26.972656v26.972656h-26.972656zm0 0" fill="#2295f1"/><path d="m491.816406 136.804688h-52.070312c-6.929688 0-12.550782 5.617187-12.550782 12.546874v52.070313c0 6.929687 5.621094 12.550781 12.550782 12.550781h52.070312c6.933594 0 12.550782-5.621094 12.550782-12.550781v-52.070313c0-6.929687-5.617188-12.546874-12.550782-12.546874zm-12.550781 52.070312h-26.964844v-26.972656h26.964844zm0 0" fill="#2295f1"/><path d="m439.746094 503.195312h52.070312c6.933594 0 12.550782-5.621093 12.550782-12.550781v-52.070312c0-6.933594-5.617188-12.546875-12.550782-12.546875h-52.070312c-6.929688 0-12.550782 5.613281-12.550782 12.546875v52.070312c0 6.929688 5.621094 12.550781 12.550782 12.550781zm12.554687-52.070312h26.964844v26.972656h-26.964844zm0 0" fill="#2295f1"/><path d="m87.300781 307.792969-.675781.15625c-6.746094 1.59375-10.925781 8.351562-9.335938 15.097656 1.363282 5.777344 6.515626 9.675781 12.203126 9.675781.957031 0 1.921874-.113281 2.890624-.34375l.671876-.15625c6.75-1.589844 10.929687-8.347656 9.335937-15.09375-1.585937-6.742187-8.34375-10.921875-15.089844-9.335937zm0 0" fill="#2295f1"/><path d="m260.878906 167.789062-.675781.160157c-6.746094 1.582031-10.929687 8.335937-9.347656 15.085937 1.351562 5.785156 6.507812 9.6875 12.207031 9.6875.945312 0 1.90625-.109375 2.875-.339844l.671875-.15625c6.75-1.582031 10.933594-8.339843 9.351563-15.082031-1.582032-6.746093-8.339844-10.9375-15.082032-9.355469zm0 0" fill="#2295f1"/><path d="m12.546875 103.125c6.9375 0 12.550781-5.617188 12.550781-12.546875v-65.148437h62.777344c6.933594 0 12.554688-5.613282 12.554688-12.546876 0-6.929687-5.621094-12.550781-12.554688-12.550781h-75.328125c-6.925781 0-12.546875 5.621094-12.546875 12.550781v77.695313c0 6.929687 5.621094 12.546875 12.546875 12.546875zm0 0" fill="#2295f1"/><path d="m627.453125.332031h-75.328125c-6.933594 0-12.554688 5.621094-12.554688 12.550781 0 6.933594 5.621094 12.546876 12.554688 12.546876h62.777344v65.148437c0 6.929687 5.613281 12.546875 12.550781 12.546875 6.925781 0 12.546875-5.617188 12.546875-12.546875v-77.695313c0-6.929687-5.621094-12.550781-12.546875-12.550781zm0 0" fill="#2295f1"/><path d="m87.875 614.695312h-62.777344v-65.144531c0-6.925781-5.613281-12.546875-12.550781-12.546875-6.925781 0-12.546875 5.621094-12.546875 12.546875v77.695313c0 6.929687 5.621094 12.550781 12.546875 12.550781h75.328125c6.933594 0 12.554688-5.621094 12.554688-12.550781 0-6.933594-5.621094-12.550782-12.554688-12.550782zm0 0" fill="#2295f1"/><path d="m627.453125 537.003906c-6.9375 0-12.550781 5.621094-12.550781 12.546875v65.144531h-62.777344c-6.933594 0-12.554688 5.617188-12.554688 12.550782 0 6.929687 5.621094 12.550781 12.554688 12.550781h75.328125c6.925781 0 12.546875-5.621094 12.546875-12.550781v-77.695313c0-6.925781-5.621094-12.546875-12.546875-12.546875zm0 0" fill="#2295f1"/></svg>
      </div>
    </div>
    <div v-show="!mode" class="fade-in" :class="{ 'blur' : $root.blur }">
      <div class="box-input">
        <span class="text-label" :class="{ 'active' : type_query }" @click="focusInput(1)">NIT</span>
        <input :disabled="$root.sending" class="type-checkbox" id="toogle" @click="focused" type="checkbox" name="name" v-model="type_query">
        <label class="estado" for="toogle"></label>
        <span class="text-label" :class="{ 'active' : !type_query }" @click="focusInput(2)">MATRÍCULA</span>
      </div>
      <div class="search-input">
        <input :disabled="$root.sending" id="focus-here" type="text" @keyup.enter="send" v-model="value_search" :placeholder="placeholder">
        <button class="btn-search button" :disabled="$root.sending" @click="send" :class="{ 'is-loading' : $root.sending }"></button>
      </div>
      <show-enterprise v-if="show_credentials" :enterprise="enterprise"></show-enterprise>
    </div>
    <div v-show="mode">
      <verify-qr></verify-qr>
    </div>
  </div>
</template>

<script>

import ShowEnterprise from './ShowEnterprise'
import VerifyQr from './VerifyQr'

import { TweenMax, TimelineMax } from 'gsap'
import SVGDrawPlugin from '../svgDraw'

export default {
  data() {
    return {
      mode: false,
      type_query: true,
      value_search: '',
      show_credentials: false,
      enterprise: {},
      show_note: false,
      data_query: {
        identificacion: '',
        matricula: ''
      },

    }
  },
  components: {
    ShowEnterprise,
    VerifyQr
  },
  computed: {
    placeholder() {
      switch (this.type_query) {
        case true:
          this.data_query.matricula = ''
          return 'Digite el NIT'
        case false:
          this.data_query.identificacion = ''
          return 'Digite la Matrícula'
        default:
          return ''
      }
    },
    nameinput() {
      switch (this.type_query) {
        case true:
          return 'identificacion'
        case false:
          return 'matricula'
        default:
          return ''
      }
    },
    status() {
      switch (this.enterprise.estado) {
        case 'MA':
          return 'Matrícula Activo'
        case 'MI':
          return 'Matrícula Inactiva'
        case 'MF':
          return 'Matrícula cancelada por cambio de jurisdicción'
        case 'MC':
          return 'Matrícula cancelada'
        case 'NA':
          return 'Matrícula no asignada o anulada'
        default:
          return ''
      }
    }
  },
  methods: {
    focusInput(t) {
      switch (t) {
        case 1:
          this.type_query = true
          break
        case 2:
          this.type_query = false
          break
        default:
          break
      }
      this.focused()
    },
    focused() {
      document.getElementById('focus-here').focus()
    },
    handleNote() {
      this.show_note = !this.show_note
    },
    send() {
      let vm = this
      vm.enterprise = {}
      vm.show_credentials = false
      vm.$root.sending = !vm.$root.sending
      vm.data_query[vm.nameinput] = vm.value_search
      if (vm.data_query[vm.nameinput] != '') {
        axios.post('https://control.ccmonteria.org.co/api/site/consultaExpedientes', vm.data_query)
        .then(function (response) {
          const r = response.data.data
          console.log(r)
          vm.enterprise = r
          if ((r.categoria == '2' && r.ultanorenovado == moment().year()) || (r.categoria == '3' && r.ultanorenovado == moment().year()) || (r.organizacion == '02' && r.ultanorenovado == moment().year()) || (r.ultanorenovado == moment().year() && r.establecimientos.length)) {
            vm.show_credentials = true
            if (r.organizacion == '02' || r.categoria == '2' || r.categoria == '3') {
              vm.$root.message = `Se encontró 1 establecimiento.`
            } else {
              vm.$root.message = `Se encontraron ${r.establecimientos.length} establecimientos.`
            }
          }
          else if (r.ultanorenovado != moment().year() && r.estado == 'MA') {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>No ha renovado al año ${moment().year()}.</span>`
          }
          else if (r.estado == 'MA' && r.establecimientos.length) {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>${vm.status}</span>`
          } else if (r.estado == 'MI') {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>${vm.status}</span>`
          } else if (r.estado == 'MF') {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>${vm.status}</span>`
          } else if (r.estado == 'MC') {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>${vm.status}</span>`
          } else if (r.estado == 'NA') {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>${vm.status}</span>`
          } else {
            vm.$root.message = `<span class='tile-alert'>${r.nombre}</span><span>No tiene establecimientos.</span>`
            vm.show_credentials = false
          }
          vm.$root.sending = !vm.$root.sending
          vm.$root.toast()
        })
        .catch(function (error) {
          var e = error.response
          if (e.status === 404) {
            vm.$root.message = e.data.message[1]
          } else {
            vm.$root.message = 'Ha ocurrido un error en el servidor, vuelva a consultar por favor.'
          }
          vm.$root.sending = !vm.$root.sending
          vm.$root.toast()
        })
      } else {
        vm.$root.message = 'El campo no puede estar vacio.'
        vm.$root.sending = !vm.$root.sending
        vm.$root.toast()
      }
    },
    changeMode() {
      this.mode = !this.mode
    }
  },
  mounted() {
    const { ja, hand, arrowContainer, certContainer, qrContainer, handContainer } = this.$refs
    TweenMax.to(ja, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(hand, 0, {
      drawSVG: "0%",
      delay: 0
    })
    TweenMax.to(ja, 3, {
      drawSVG: true,
      delay: 1
    })
    TweenMax.to(hand, 3, {
      drawSVG: true,
      delay: 1
    })

  }
}
</script>
<style lang="scss">
  .pending {
    & .status {
      background: #fc975c;
      color: #fff;
    }
  }
  .active {
    & .status {
      background: #34c84a;
      color: #fff;
    }
  }
  .suspension {
    & .status {
      background: #fc605c;
      color: #fff;
    }
  }
  .main-title {
    color: #002745;
    font-size: 2.5rem;
    display: block;
    text-align: center;
    font-family: sans-serif;
    font-weight: bold;
    letter-spacing: -2px;
  }
  .btn-change-mode {
    position: absolute;
    top: 0;
    right: 0;
    width: 70px;
    transition: all .3s ease;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
    & svg {
      width: inherit;
      height: auto;
    }
    & .arrow {
      width: 100%;
    }
    & .cert, & .qr-btn {
      position: absolute;
      width: 30px;
      transition: all .3s ease;
    }
    & .cert {
      bottom: 2px;
      left: -8px;
      &.active {
        transform: scale(1.5);
      }
    }
    & .qr-btn {
      top: 8px;
      right: -4px;
      &.active {
        transform: scale(1.5);
      }
    }
  }
  .btn-search {
    width: 100px;
    height: 100%;
    background: radial-gradient(circle farthest-corner at 200px 0, #00518f, #2196F3);
    border: 0;
    border-radius: 0 40px 40px 0;
    font-weight: bold;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    &:after {
      content: '';
      position: absolute;
      background: url(../../images/icons/search_beauty.svg);
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-position: center;
      background-size: 30px;
      background-repeat: no-repeat;
    }
    &:hover, &:focus {
      background: radial-gradient(circle farthest-corner at 200px 0, darken(#00518f, 5%), #2196F3);
      color: #fff;
    }
  }
  .search-input {
    margin: 40px 0;
    display: flex;
    align-items: center;
    border: 1px solid #cac9c9;
    border-radius: 40px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.29);
    background: #fff;
    position: relative;
    & input {
      width: calc(100% - 100px);
      border: 0;
      color: #2295f1;
      background: transparent;
      font-size: 1.5rem;
      text-align: center;
      padding: 16px 10px;
      outline: none;
      border-radius: 40px 0 0 40px;
    }
  }
  .query-section {
    padding: 40px 0;
    position: relative;
    animation: 1s fade-out-card ease;
    margin-top: 90px;
    & .label {
      color: #dcb44f;
      font-size: 1.5rem;
      margin-bottom: 40px;
      text-align: center;
      font-weight: 400;
    }
  }
  .estado:focus:before {
    box-shadow: 0px 0px 0px 4px rgba(72, 85, 121, 0.28)
  }

  .box-input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-label {
    background: radial-gradient(circle farthest-corner at 200px 0, #00518f, #2196F3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    &.active {
      font-weight: bold;
      border-bottom: 1px solid #2295f1;
    }
  }
  .type-checkbox {
  	display: none;
  	+ label {
      margin: 0 20px;
  		$time: 300ms;
  		display: block;
  		width: 160px;
  		height: 45px;
  		background: radial-gradient(circle farthest-corner at 200px 0, #00518f, #2196F3);
  		border-radius: 22px;
  		box-shadow: 0px 0px 25px -3px rgba(0,0,0,0.4);
  		transition: all $time cubic-bezier(0.79,-0.01, 0.36, 1);
  		cursor:pointer;
  		position: relative;

  		span {
  			position: absolute;
  			color:white;
  			font-size: 12px;
        font-family: 'Varela Round', sans-serif;
  		}

  		span.aprobado {
  			top:50%;
  			transform:translateY(-50%);
  			left:2.5em;
  			animation:left-check 300ms ease-in-out;
  			@keyframes left-check{
  				0% {
  					opacity: 0;
  					left:5em;
  				}
  				100% {
  					opacity: 1;
  					left:2.5em;
  				}
  			}
  		}

  		span.desaprobado {
  			top:50%;
  			transform:translateY(-50%);
  			right:1.3em;
  			display: none;
  			animation:right-check 300ms ease-in-out;
  			@keyframes left-check{
  				0% {
  					opacity: 0;
  					right:5em;
  				}
  				100% {
  					opacity: 1;
  					right:1.3em;
  				}
  			}
  		}

  		&:before {
  			display: block;
  			content:"";
  			width: 35px;
  			height: 35px;
  			border-radius: 50%;
  			background-color: white;
  			box-shadow: 0px 0px 25px -3px rgba(0,0,0,0.4);
  			position: relative;
  			top:50%;
  			transform: translateY(-50%);
  			left: 117px;
  			transition: left $time cubic-bezier(0.79,-0.01, 0.36, 1);
  		}
  	}

  	&:checked {
  		+ label {
  			background-color: #3d8ef2;

  			span.aprobado {
  				display: none;
  			}
  			span.desaprobado {
  				display: block;
  			}

  			&:before {
  				left:8px;
  			}
  		}
  	}
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #ccc;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #ccc;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: #ccc;
  }

  .note {
    color: #fff;
    border: 1px solid;
    text-align: center;
    font-size: .8rem;
    border-radius: 3px;
  }
  .help-btn {
    position: absolute;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: 63px;
    left: -1px;
    top: -60px;
    transform: rotate(-183deg);
  }
  .ja {
    stroke-width: 8px;
    fill: transparent;
    stroke: #2295f1;
  }
  .hand {
    stroke-width: 8px;
    fill: transparent;
    stroke: #2295f1;
  }
  .move-touch {
    animation: 1s moveTouch ease alternate infinite;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseSearch.vue